import { gql } from "@/services/httpAdapter";

const SalesMetricsFragment = gql`
	fragment SalesMetrics on SalesAnalyticsItem {
		daily {
			backGross
			backPVR
			frontGross
			frontPVR
			totalGross
			totalPVR
			heldGross
		}
		projection {
			current {
				backGross
				backPVR
				frontGross
				frontPVR
				totalGross
				totalPVR
				heldGross
				heldPVR
			}
			projected {
				backGross
				backPVR
				frontGross
				frontPVR
				totalGross
				totalPVR
				tradeGrossPace
				heldPVR
			}
		}
		trades {
			held
			perTrade
			total
		}
		summary {
			daysWorked
			deliveredToday
			salesPace
			totalDelivered
			totalTrades
			tradePace
		}
	}
`;

export { SalesMetricsFragment };
